import { render, staticRenderFns } from "./ProjectViewSidebar.vue?vue&type=template&id=1041ad79&"
import script from "./ProjectViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ProjectViewSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1041ad79')) {
      api.createRecord('1041ad79', component.options)
    } else {
      api.reload('1041ad79', component.options)
    }
    module.hot.accept("./ProjectViewSidebar.vue?vue&type=template&id=1041ad79&", function () {
      api.rerender('1041ad79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/projects/partials/ProjectViewSidebar.vue"
export default component.exports